export enum DISPLAY_TYPES {
  EVERYONE = "everyone",
  SELECTED = "selected",
  NOBODY = "nobody",
}

export enum SETTINGS_COLLAPSES {
  PROFILE = "profile",
  DISPLAY = "display",
  THEME = "theme",
  PRIVACY = "privacy",
  SECURITY = "security",
  HELP = "help",
  SYSTEM = "system",
  NOTIFICATION_SETTING = "notice_setting",
  DATA = "data",
}
export interface DisplayOpt {
  label: string;
  value: DISPLAY_TYPES;
}

export const DisplayTypes: Array<DisplayOpt> = [
  { label: "Everyone", value: DISPLAY_TYPES.EVERYONE },
  { label: "Nobody", value: DISPLAY_TYPES.NOBODY },
  { label: "Selected", value: DISPLAY_TYPES.SELECTED },
];

export enum STATUS_TYPES {
  ACTIVE = "Active",
  AWAY = "Away",
  DO_NOT_DISTURB = "Do not disturb",
}

export enum ONLINE_STATUS{
  ACTIVE = 1, 
  AWAY = 2,
  OFFLINE = 3,
  BUSY = 4
}

export enum CONTENT_TITLE_NAME{
  PAYMENT = "ชำระเงิน",
  SASTIFY = "ประเมินความพึงพอใจ",
  CONFIRM_PO = "ยืนยันการสั่งซื้อ",
  NEWS = "ข่าวสาร",
  PROMOTION = "โปรโมชั่น",
  DELIVERY_STATUS = "สถานะส่งสินค้า" ,
  NON_RECEIVING_PRODUCT = "สินค้าค้างรับ"
}

export enum FILTER_CHAT_ROOM_TABS{
  CHAT_ROOM = "ห้องแชท",
  SALES = "Sale",
  CS = "CS",
  PROVINCE = "จังหวัด"
}